/**
 * Stable selection id for a patient picker row: prefer the real profile id
 * when the session is linked; fall back to the display name so unlinked
 * patients remain selectable (the agent can still resolve by name).
 *
 * Kept in a sibling ``.ts`` file so ``PatientPickerList.tsx`` only exports
 * the React component (react-refresh/only-export-components ratchet).
 */
export const patientSelectionId = (item: {
  patientId?: string;
  patientName: string;
}): string => item.patientId ?? item.patientName;
